import { Component, Injectable } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { DialogWizardComponent } from './dialog-wizard.component';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogWizardService {
  constructor(private dialogService: NbDialogService) {}

  async openWizard(component: any, initialData: any = {}): Promise<any> {
    const dialogRef = this.dialogService.open(component, {
      context: initialData,
      closeOnBackdropClick: false,
      hasBackdrop: true,
    });

    return await firstValueFrom(dialogRef.onClose);
  }
}
